import { AssetListItem } from '../services'

export const getAssetDetailPath = (
    row: AssetListItem,
    options?: { includeVersion?: boolean }
): string => {
    const basePath = `/assets/${row.asset_slug}`
    const includeVersion = options?.includeVersion ?? true
    if (includeVersion && row.processing_version_id) {
        return `${basePath}?version=${row.processing_version_id}`
    }
    return basePath
}
